<!-- FAB button -->
<button *ngIf="enabled" class="chat-fab" (click)="toggle()" [class.active]="open" [class.shifted]="open">
  <i class="fa-brands fa-claude" *ngIf="!open"></i>
  <i class="fa fa-times" *ngIf="open"></i>
</button>

<!-- Drawer -->
<div *ngIf="enabled" class="chat-drawer" [class.open]="open">
  <div class="chat-header">
    <span>AI Assistant</span>
    <button class="btn-clear" (click)="clear()" title="Clear chat">
      <i class="fa fa-trash"></i>
    </button>
  </div>

  <div class="chat-messages" #messagesContainer>
    <div *ngFor="let msg of messages; trackBy: trackByIndex"
         class="chat-message"
         [class.user]="msg.role === 'user'"
         [class.assistant]="msg.role === 'assistant'">
      <div *ngIf="msg.role === 'user'" class="message-content">{{ msg.content }}</div>
      <div *ngIf="msg.role === 'assistant'" class="message-content markdown" [innerHTML]="renderMarkdown(msg.content)"></div>
      <div *ngIf="msg.toolCalls && msg.toolCalls.length" class="tool-calls">
        <details *ngFor="let tc of msg.toolCalls">
          <summary>🔧 {{ tc.name }}</summary>
          <pre class="tool-result">{{ tc.result }}</pre>
        </details>
      </div>
    </div>
    <div *ngIf="loading" class="chat-message assistant">
      <div class="message-content typing">Thinking...</div>
    </div>
  </div>

  <div class="chat-input">
    <input
      [(ngModel)]="input"
      (keydown.enter)="send()"
      placeholder="Ask about your IoT data..."
      [disabled]="loading"
    />
    <button (click)="send()" [disabled]="loading || !input.trim()">
      <i class="fa fa-paper-plane"></i>
    </button>
  </div>
</div>
